'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createHashHistory');
module.exports = require('./index.js').createHashHistory;



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/history/createHashHistory.js
// module id = 539
// module chunks = 99